import { GeoCodeInput } from "@covertree/new-business-graphql";
import { ClaimsCheckForm } from "@covertree/new-business-forms";

export function transformToFormerAddress({
  address,
  lotUnit,
}: ClaimsCheckForm): GeoCodeInput | null {
  if (!address?.value) {
    return null;
  }

  return {
    city: address.value.city,
    state: address.value.state,
    streetAddress: address.value.mainAddressLine,
    zipCode: address.value.postCode,
    unitNumber: lotUnit || address.value.lotUnit || undefined,
  };
}
